'use strict';

require('./FormGroupToggle.scss');

const React = require('react'),
    PropTypes = React.PropTypes,
    mui = require('material-ui'),
    set = require('lodash/object').set,
    get = require('lodash/object').get,
    BasicFormGroup = require('../BasicFormGroup'),
    {Toggle} = mui;

const FormGroupToggle = React.createClass({displayName: "FormGroupToggle",

    propTypes: Object.assign({}, BasicFormGroup.propTypes, {
        label: PropTypes.string,
        onChange: PropTypes.func,
        messageError: PropTypes.string,
        writerAttribute: PropTypes.string,
        readerAttribute: PropTypes.string,
        name: PropTypes.string,
        decimalDigits: PropTypes.bool,
        formatDecimal: PropTypes.string,
        amountDecimals: PropTypes.number,
        isRequired: PropTypes.bool,
        onEnter: PropTypes.func,
        className: PropTypes.string
    }),

    _el: null,

    componentDidMount() {
        const {operationsHolder} = this.props;
        // React will throw a warning for bind the context with each operation, but we need it, otherwise
        // we don't have access to the context of the component when need to perform each operation.
        operationsHolder.addValidator(this.isValid.bind(this));
        operationsHolder.addCleaner(this.clean.bind(this));
        operationsHolder.addItemProvider(this.getValue.bind(this));
    },

    clean() {
    },

    getValue() {
        const {writerAttribute, readerAttribute} = this.props;
        const value = this._el.isToggled();
        const writerAttributeSafe = writerAttribute || readerAttribute; // make writer attribute optionally
        const wrapper = set({}, writerAttributeSafe, value);

        return wrapper;
    },

    isValid() {
        this.setState({messageError: ''});
        return true;
    },

    _onEnter() {
        if (this.props.onEnter) {
            this.props.onEnter();
        }
    },

    onChange() {
        this._el.setToggled(!this._el.isToggled());
    },

    render() {
        const {isDisabled, label, value, readerAttribute, isImmutable, isEditMode, className} = this.props;

        // is disabled input
        const isDisabledInput = !!isDisabled || isImmutable && isEditMode;

        // prepare specific classes
        let textFieldClassName = 'form-group form-group-toggle';
        textFieldClassName += (isDisabledInput ? ' is-disabled' : '');
        if (className) {
            textFieldClassName += ' ' + className;
        }
        const classNameElement = 'form-group-toggle-input' + (isDisabledInput ? ' is-disabled' : '');

        // the input value
        let safeValue = value === undefined ? false : readerAttribute ? get(value, readerAttribute, '') : value;

        return (
            React.createElement("div", {className: textFieldClassName}, 
                React.createElement("label", null, label), 
                React.createElement(Toggle, {
                    ref:  ref => this._el = ref, 
                    className: classNameElement, 
                    floatingLabelStyle: {color: '#fff !important', fontWeight: '300'}, 
                    LabelStyle: {color: '#fff !important', fontWeight: '300'}, 
                    onEnterKeyDown: this._onEnter, 
                    defaultToggled: safeValue, 
                    floatingLabelText:  label ? label : '', 
                    style: {width: '100%', color: 'white !important', fontWeight: '300'}, 
                    disabled: isDisabledInput, 
                    errorText:  get(this.state, 'messageError', '') }
                )
            )
        );
    }
});

module.exports = FormGroupToggle;



/** WEBPACK FOOTER **
 ** ./src/components/Commons/BasicForm/FormGroupToggle/FormGroupToggle.jsx
 **/